const fileExtensions = [
    'pdf',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'csv',
    'ppt',
    'pptx',
    'txt',
    'rtf',
    'jpg',
    'jpeg',
    'png',
    'gif',
    'webp',
    'svg',
    'zip',
    'rar',
    '7z'
];

export function isLinkPublished(link, now = new Date()) {
    
    const publishFrom = link?.PublishFrom
        ? new Date(link.PublishFrom)
        : null;

    const publishUntil = link?.PublishUntil
        ? new Date(link.PublishUntil)
        : null;

    if (publishFrom && publishFrom > now) {
        return false;
    }

    if (publishUntil && publishUntil < now) {
        return false;
    }

    return true;
}

export function getLinkPublishStatus(link, now = new Date()) {
    const publishFrom = link?.PublishFrom
        ? new Date(link.PublishFrom)
        : null;

    const publishUntil = link?.PublishUntil
        ? new Date(link.PublishUntil)
        : null;

    if (publishFrom && publishFrom > now) {
        return 'scheduled';
    }

    if (publishUntil && publishUntil < now) {
        return 'expired';
    }

    return null;
}

export function matchesFilter(value, filter) {
    if (!value || !filter) return false;

    return value
        .toString()
        .toLowerCase()
        .includes(filter.trim().toLowerCase());
}

export function getAntiForgeryToken() {
    return document.querySelector(
        'input[name="__RequestVerificationToken"]'
    )?.value ?? null;
}

export function joinUrl(baseUrl, path) {
    return `${baseUrl.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
}

export async function requestJson(
    url,
    {
        method = 'GET',
        body = null
    } = {}
) {
    const headers = {
        Accept: 'application/json'
    };

    if (body !== null) {
        headers['Content-Type'] = 'application/json';
    }

    const token = getAntiForgeryToken();

    if (token) {
        headers.RequestVerificationToken = token;
    }

    const response = await fetch(url, {
        method,
        credentials: 'same-origin',
        headers,
        body: body !== null
            ? JSON.stringify(body)
            : null
    });

    if (response.status === 204) {
        return null;
    }

    const text = await response.text();

    let data = null;

    if (text) {
        try {
            data = JSON.parse(text);
        } catch {
            data = text;
        }
    }

    if (!response.ok) {
        const message =
            data?.detail ||
            data?.title ||
            data ||
            `Request failed with status ${response.status}.`;

        throw new Error(message);
    }

    return data;
}

export function getFileExtension(url) {
    if (!url) {
        return '';
    }

    try {
        const pathname = new URL(url, window.location.origin).pathname;
        const fileName = pathname.split('/').pop() || '';
        const index = fileName.lastIndexOf('.');

        return index >= 0
            ? fileName.substring(index + 1).toLowerCase()
            : '';
    } catch {
        return '';
    }
}

export function getLinkIcon(url) {
    const extension = getFileExtension(url);

    switch (extension) {
        case 'pdf':
            return 'fa-file-pdf';

        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
        case 'webp':
        case 'svg':
            return 'fa-file-image';

        case 'doc':
        case 'docx':
            return 'fa-file-word';

        case 'xls':
        case 'xlsx':
        case 'csv':
            return 'fa-file-excel';

        case 'ppt':
        case 'pptx':
            return 'fa-file-powerpoint';

        case 'zip':
        case 'rar':
        case '7z':
            return 'fa-file-archive';

        case 'txt':
        case 'rtf':
            return 'fa-file-alt';

        default:
            return 'fa-link';
    }
}